import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=c558d5cc&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c558d5cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c558d5cc')) {
      api.createRecord('c558d5cc', component.options)
    } else {
      api.reload('c558d5cc', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=c558d5cc&scoped=true&", function () {
      api.rerender('c558d5cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27JJw5TlM5gwZ/JS/comp/Accordion.vue"
export default component.exports